import { render, staticRenderFns } from "./VacancyDetails.vue?vue&type=template&id=00e74c05&"
import script from "./VacancyDetails.vue?vue&type=script&lang=js&"
export * from "./VacancyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports